import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class DeviceContextInterceptor implements HttpInterceptor {

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let targetUrl = request.url;

    if (typeof window !== 'undefined' && (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1')) {
      targetUrl = targetUrl.replace(/^https?:\/\/(api\.tecnologiaasap\.com\.br|apiv3\.plataformaasap\.com\.br)/i, 'http://127.0.0.1:8000');
    }

    // Normaliza URLs com possíveis barras duplas acidentais (mantendo https://)
    const cleanedUrl = targetUrl.replace(/([^:]\/)\/+/g, '$1');

    // Clona a requisição injetando o header de contexto
    const secureReq = request.clone({
      url: cleanedUrl,
      headers: request.headers.set('X-Device-Context', 'asap_authorized_access')
    });

    return next.handle(secureReq);
  }
}
